<div class="serial-confirmation-dialog">
  <div class="serial-confirmation-icon" aria-hidden="true">
    <mat-icon>info</mat-icon>
  </div>

  <h2 mat-dialog-title>Serial number not added</h2>

  <mat-dialog-content>
    <p>Please enter the serial number or upload a serial number image if it is visible on your bat.</p>
    <p class="serial-confirmation-note">If it is not visible, you may continue without it.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" class="serial-confirmation-back" [mat-dialog-close]="false" cdkFocusInitial>
      Go Back
    </button>
    <button mat-raised-button type="button" class="serial-confirmation-continue" [mat-dialog-close]="true">
      Continue Without Serial
    </button>
  </mat-dialog-actions>
</div>
